import axios from "axios";
import toast from "react-hot-toast";
import { cryptoService } from "./crypto";
import { SecurityStatus } from "../Config";
import { getSecureItem } from "./SecureStorage";


 export const  IMAGE_URL = "https://seaberryhrmsapi.initstore.com/uploads" 
 const API_URL = "https://seaberryhrmsapi.initstore.com"; 

//  export const  IMAGE_URL = "https://api.attukal.org/uploads" 
//  const API_URL = "https://api.attukal.org"

//  export const  IMAGE_URL = "http://localhost:5008/uploads"
// export const  IMAGE_URL = "http://localhost:5008/uploads" 

// export const  IMAGE_URL = "https://hrmsapi.chittilappillysquare.org/uploads"
// const API_URL = "https://hrmsapi.chittilappillysquare.org";

// export const IMAGE_URL = "http://localhost:5007/uploads"
// const API_URL = "http://localhost:5007";

// export const  IMAGE_URL = "https://api.hrms.seaberryfoods.com/uploads" 
//  const API_URL = "https://api.hrms.seaberryfoods.com"

//    export const  IMAGE_URL = "https://api.attukal.org/uploads"
//  const API_URL = "https://api.attukal.org"

// const API_URL = "https://excellentapi.initstore.com"; 
// export const  IMAGE_URL = "https://excellentapi.initstore.com/uploads" 


//  const API_URL = "https://attendit.api.initstore.com";
// export const  IMAGE_URL  = "https://attendit.api.initstore.com";

//  const API_URL = 'attukaluat.connect.initstore.com'
//  export const  IMAGE_URL = "https://attukaluat.connect.initstore.com/uploads"

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* =========================
   REQUEST INTERCEPTOR
   ========================= */
apiClient.interceptors.request.use(
  (config) => {
    // Attach token
    const token = getSecureItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 🚫 Skip encryption for FormData (file upload)
    if (config.data instanceof FormData) {
      return config;
    }

    // 🔐 ENCRYPTION LOGIC - Only if SecurityStatus = "0"
    if (
      SecurityStatus === "0" && // ← ENABLED encryption
      config.data &&
      typeof config.data === "object"
    ) {
      const encrypted = cryptoService.encrypt(JSON.stringify(config.data));
      config.data = {
        data: encrypted,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
   ========================= */
apiClient.interceptors.response.use(
  (response) => {
    // 🔓 DECRYPTION LOGIC - Only if SecurityStatus = "0"
    if (
      SecurityStatus === "0" && // ← ENABLED decryption
      response.data?.data &&
      typeof response.data.data === "string"
    ) {
      try {
        const decrypted = cryptoService.decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
      } catch (err) {
        console.error("❌ Response decryption failed:", err);
        // Don't throw - let original encrypted response through
      }
    }

    return response;
  },
  (error) => {
    // Global 401 handling
    if (error.response?.status === 401) {
      toast.error(
        "Someone else logged in on another device. Please login again."
      );

      setTimeout(() => {
        localStorage.removeItem("authToken");
        window.location.href = "/login";
      }, 1000);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
